import React from 'react';

/* Un render de markdown mínimo, para las minutas y los avances.

   No entra una librería por esto: el bundle ya pesa y de markdown solo se usa
   una porción chica —títulos, negrita, viñetas, tareas—. Lo que no está acá se
   muestra como texto, que es exactamente lo que pasaba antes: nunca se rompe.

   El orden importa: primero se escapa TODO el html que venga en el texto, y
   recién después se insertan las etiquetas propias. Así un cliente no puede
   meter markup en una minuta. */

const escapar = (s) => String(s)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/* Lo de adentro de una línea: negrita, cursiva, código y enlaces */
function enLinea(t) {
  return t
    .replace(/`([^`]+)`/g, '<code>$1</code>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[\s(])\*([^*\n]+)\*/g, '$1<em>$2</em>')
    .replace(/(^|[\s(])_([^_\n]+)_/g, '$1<em>$2</em>')
    .replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>')
    // Los enlaces sueltos se hacen clickeables, pero no los que ya están adentro de un href
    .replace(/(^|[\s])(https?:\/\/[^\s<]+)/g, '$1<a href="$2" target="_blank" rel="noreferrer">$2</a>');
}

export function aHtml(texto) {
  if (!texto) return '';
  const lineas = escapar(texto).replace(/\r/g, '').split('\n');
  const salida = [];
  let lista = null;        // 'ul' | 'ol' | null
  let parrafo = [];

  const cerrarParrafo = () => {
    if (parrafo.length) { salida.push(`<p>${enLinea(parrafo.join('<br>'))}</p>`); parrafo = []; }
  };
  const cerrarLista = () => { if (lista) { salida.push(`</${lista}>`); lista = null; } };
  const cerrarTodo = () => { cerrarParrafo(); cerrarLista(); };
  const abrirLista = (tipo, clase = '') => {
    if (lista !== tipo) { cerrarLista(); salida.push(`<${tipo}${clase}>`); lista = tipo; }
  };

  for (const linea of lineas) {
    const l = linea.trim();

    if (!l) { cerrarTodo(); continue; }

    const titulo = l.match(/^(#{1,4})\s+(.*)$/);
    if (titulo) {
      cerrarTodo();
      const nivel = Math.min(titulo[1].length + 2, 5);   // # ya es grande de más para una minuta
      salida.push(`<h${nivel}>${enLinea(titulo[2])}</h${nivel}>`);
      continue;
    }

    if (/^(-{3,}|_{3,}|\*{3,})$/.test(l)) { cerrarTodo(); salida.push('<hr>'); continue; }

    // Tareas: "- [ ] algo" / "- [x] algo"
    const tarea = l.match(/^[-*]\s+\[([ xX])\]\s+(.*)$/);
    if (tarea) {
      cerrarParrafo(); abrirLista('ul', ' class="md-tareas"');
      const hecha = tarea[1].toLowerCase() === 'x';
      salida.push(`<li class="${hecha ? 'hecha' : ''}"><span class="md-casilla">${hecha ? '✓' : ''}</span><span>${enLinea(tarea[2])}</span></li>`);
      continue;
    }

    const viñeta = l.match(/^[-*•]\s+(.*)$/);
    if (viñeta) { cerrarParrafo(); abrirLista('ul'); salida.push(`<li>${enLinea(viñeta[1])}</li>`); continue; }

    const numerada = l.match(/^\d+[.)]\s+(.*)$/);
    if (numerada) { cerrarParrafo(); abrirLista('ol'); salida.push(`<li>${enLinea(numerada[1])}</li>`); continue; }

    cerrarLista();
    parrafo.push(l);
  }
  cerrarTodo();
  return salida.join('');
}

/* El componente que se usa en las pantallas. Si el texto no trae nada de
   markdown, igual sale bien: son párrafos. */
export default function Texto({ texto, className = '' }) {
  if (!texto) return null;
  return <div className={'md ' + className} dangerouslySetInnerHTML={{ __html: aHtml(texto) }} />;
}
